// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimMarketingReferenceInfo, {getDefaultState as getClaimMarketingReferenceInfoDefaultState} from './claim-marketing-reference-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimUseAmount, {getDefaultState as getClaimUseAmountDefaultState} from './claim-use-amount';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimMaintenancePlan = t.struct({
    additionalComments: t.String,
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    comments: t.String,
    customerSummary: CustomerSummary,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    machineType: KeyValuePair,
    noTravel: t.Bool,
    pin: t.String,
    planName: KeyValuePair,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimMarketingReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    serviceDate: t.maybe(t.Number),
    serviceInterval: KeyValuePair,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    subClaimType: KeyValuePair,
    useAmount: ClaimUseAmount,
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimMaintenancePlan',
    strict: true
});

export const getDefaultState = () => new ClaimMaintenancePlan({
    additionalComments: '',
    allowedActions: [
        new ClaimAction({
            actionName: 'SAVE_VALD',
            id: 'SAVE_VALD',
            mode: 'CHG'
        })
    ],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: {
        key: 'ZZMK',
        value: ''
    },
    claimValueDetails: getClaimValueDetailsDefaultState(),
    comments: '',
    customerSummary: getCustomerSummaryDefaultState(),
    errors: [],
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    isDuplicateClaim: false,
    isEditable: true,
    machineType: getKeyValuePairDefaultState(),
    noTravel: false,
    pin: '',
    planName: getKeyValuePairDefaultState(),
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: new ClaimMarketingReferenceInfo({
        ...getClaimMarketingReferenceInfoDefaultState(),
        referenceNumber2: '',
        repairNumber: ''
    }),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    serviceDate: null,
    serviceInterval: getKeyValuePairDefaultState(),
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    subClaimType: new KeyValuePair({
        key: 'MTC',
        value: ''
    }),
    useAmount: getClaimUseAmountDefaultState(),
    validationFailed: false,
    version: ''
});

ClaimMaintenancePlan.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimMaintenancePlan.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimMaintenancePlan.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimMaintenancePlan;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-maintenance-plan.js